import courseBanner from '@/../../public/storage/images/course-banner.webp';
import Banner from '@/components/Banner';
import CourseCard from '@/components/CourseCard';
import { Reveal } from '@/components/Reveal';
import ShareDialog from '@/components/ShareDialog';
import { Button } from '@/components/ui/button';
import {
  Carousel,
  CarouselContent,
  CarouselControls,
  CarouselItem,
} from '@/components/ui/carousel';
import Typography from '@/components/ui/typography';
import Band from '@/Layouts/Band';
import SectionLayout from '@/Layouts/SectionLayout';
import { Course, CourseCategory } from '@/types';
import { Link } from '@inertiajs/react';
import { MoveRight } from 'lucide-react';

type CourseDetail = Pick<
  Course,
  | 'title'
  | 'slug'
  | 'description'
  | 'image_url'
  | 'rating_count'
  | 'review_count'
>;
type Categories = Pick<
  CourseCategory<CourseDetail>,
  'title' | 'slug' | 'courses'
>;

const Index = ({ categories }: { categories: Categories[] }) => {
  return (
    <>
      <Banner
        image={courseBanner}
        alt="Course Banner"
        width={1600}
        height={1067}
        tagline="Skill mastery, your way"
        title="Explore Professional & Skill Development Courses"
        description="Choose a course based on your career goal, creative interest,
                age group and preferred learning format. Samuthrika Academy brings
                together practical courses across fashion, beauty, music, dance and
                other skill-development areas."
      >
        <ShareDialog
          url={window.location.href}
          title={
            'Explore Professional & Skill Development Courses - ' +
            import.meta.env.VITE_APP_NAME
          }
          content="Choose a course based on your career goal, creative interest, age group and preferred learning format. Samuthrika Academy brings together practical courses across fashion, beauty, music, dance and other skill-development areas."
        />
      </Banner>

      {categories.map(
        (category, index) =>
          category.courses.length > 0 && (
            <Band
              key={category.slug}
              tone={index % 2 ? 'surface' : 'raised'}
              seam={index > 0}
            >
              <SectionLayout space="lg">
                <Reveal className="flex flex-wrap items-end justify-between gap-4">
                  {/* h2, not Display3's default h3: the Banner above carries
                      this page's h1 and nothing else sits between it and this
                      section heading. */}
                  <Typography.Display3 as="h2">
                    {category.title}
                  </Typography.Display3>
                  <Button asChild variant="outline">
                    <Link
                      href={route('courses.showCategory', category.slug)}
                      className="shrink-0"
                    >
                      View all
                      <MoveRight size={16} className="ml-2" />
                    </Link>
                  </Button>
                </Reveal>

                <Carousel className="flex w-full flex-col gap-6">
                  <CarouselContent className="-ml-4">
                    {category.courses.map((course) => (
                      <CarouselItem
                        key={course.slug}
                        /* Matches the home page's featured rail: three across
                           at the widest, not four. */
                        className="basis-11/12 pl-4 sm:basis-1/2 lg:basis-1/3"
                      >
                        <CourseCard category={category} course={course} />
                      </CarouselItem>
                    ))}
                  </CarouselContent>
                  <CarouselControls />
                </Carousel>
              </SectionLayout>
            </Band>
          )
      )}
    </>
  );
};

export default Index;
